<template>
    <div class="container-fluid">
        <h1>Посещение {{userHash}} <span class="btn btn-primary" @click="goBack">Вернуться назад</span></h1>

        <div v-if="!loaded">
            <font-awesome-icon icon="spinner" spin></font-awesome-icon>
        </div>
        <div v-if="loaded" style="overflow-y: auto">
            <dx-data-grid
                    :data-source="visits"
                    :columns="columns"
                    :show-borders="true"
                    :hoverStateEnabled="true"
                    :wordWrapEnabled="true"
                    :allowColumnResizing="true"
                    @row-prepared="onRowPrepared"
            >
            </dx-data-grid>
        </div>
    </div>
</template>

<script>
    import {DxDataGrid} from 'devextreme-vue/data-grid';


    import axios from 'axios';
    import {mapState} from "vuex";

    export default {
        name: "VisitReport",
        data() {
            return {
                loaded: false,
                visits: [],
                columns: [
                    {
                        dataField: 'visit_ts',
                        caption: 'Дата',
                        width: 150
                    },
                    {
                        dataField: 'page_name',
                        caption: 'Страница',
                        width: 150
                    },
                    {
                        dataField: 'lead_source',
                        width: 150
                    },
                    {
                        dataField: 'referrer',
                        width: 150
                    },
                    {
                        dataField: 'user_agent',
                        width: 150
                    },

                ]
            }
        },
        computed: {
            ...mapState({
                domain: state => state.domains.selectedDomain,
            }),
            userHash() {
                return this.$route.query['userHash']
            }
        },
        methods: {
            load() {
                let app = this;
                app.loaded = false;
                app.visits = [];
                if (!this.domain) return;
                axios.post('/api/visit/report/' + this.domain.id, {userHash: app.userHash})
                    .then(function (resp) {
                        app.visits = resp.data;
                        app.loaded = true;
                    })
                    .catch(function () {
                        alert("Невозможно загрузить информацию о посещении");
                    });
            },
            goBack() {
                this.$router.back();
            },
            onRowPrepared(e) {
                if (e.rowType === 'data' && !e.data.id ) {
                    e.rowElement.classList.add('table-success');
                }
            }
        },
        mounted() {
            this.load();
        },
        watch: {
            domain() {
                this.load();
            }
        },
        components: {
            DxDataGrid
        }
    }
</script>

<style scoped>

</style>